import React, { useRef, useState, useEffect } from 'react';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import logo from 'assets/img/Logo-Humano.png';
import { Formik } from 'formik';
import { isBrowser } from "react-device-detect";
import { NavLink } from 'react-router-dom';
import ReCAPTCHA from 'react-google-recaptcha';
import Utils from '../../utils';
import { post, getAnonymous } from 'services';
import { useHistory } from "react-router";
import Alerts from 'utils/alerts' 
import Spinner from 'react-bootstrap/Spinner';
import { connect } from 'react-redux';
import { SetUser } from "redux/actions/userActions";
import { SetLoggedIn } from "redux/actions/isLoggedInActions";
import { SetLoading } from "redux/actions/loadingActions";

let yup = require('yup');
const Swal = require('sweetalert2');

const marginTopTen = {
  marginBottom: 10
}

const logoStyle = {
  ...marginTopTen,
  marginBottom: 10,
  width: 150,
  marginRight: 30
}


const loadingClases = {
  border: 'solid',
  borderRadius: '50%',
  borderRightColor: 'transparent'
}

const getParams = (url) => {
  let params = {};
  let parser = document.createElement('a');
  parser.href = url;
  let query = parser.search.substring(1);
  let vars = query.split('&');
  for (var i = 0; i < vars.length; i++) {
      let pair = vars[i].split('=');
      params[pair[0]] = decodeURIComponent(pair[1]);
  }
  return (!params.hasOwnProperty('')) ? params : {};
};

const ChangePasswordStepTwo = (props) => {
  const history = useHistory();
  const [reCAPTCHA, setReCAPTCHA] = useState('');
  const [changePasswordEmail, setChangePasswordEmail] = useState('');
  const reRef = useRef();
  const [formContent, setFormContent] = useState({
    userName:  '',
    newPassword: '',
    confirmNewPassword: ''
  });
  const schema = yup.object({
    userName: yup.string().email("Debe ser un correo").required('El usuario es requerido'),
    newPassword: yup.string().matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*]){8,}/, "Debe poseer mínimo 8 carácteres, una mayúscula, una minúscula y un carácter especial").required('La nueva contraseña es requerida'),
    confirmNewPassword: yup.string().matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*]){8,}/, "Debe poseer mínimo 8 carácteres, una mayúscula, una minúscula y un carácter especial").required('La confirmación de la nueva contraseña es requerida')
  });

  useEffect(() => {
    (async function mounted() {
      
      try {
        props.SetLoading(true);
        const paramsObject = getParams(props.location.search);
        const hasParameters = Object.keys(paramsObject).length !== 0 && paramsObject.constructor === Object;
        if (hasParameters && ('token' in paramsObject)) {
          const response = await getAnonymous(`Usuario/ChangePasswordConfirm?token=${paramsObject.token}`);
          const { data } = response; 
          setChangePasswordEmail(data.email);
          setFormContent({
            userName: data.email,
            newPassword: '',
            confirmNewPassword: ''
          });
        } 
      } catch (error) {
        console.log(error)
        Alerts.operationFail()
      } finally {
        props.SetLoading(false);
      }
    
    })();
  }, [])

  const onSumitted = async (data) => {
    if (data.newPassword === data.confirmNewPassword) {
      try {
        props.SetLoading(true);
        const dto = {
          username: changePasswordEmail,
          password: data.newPassword,
          recaptcha: reCAPTCHA
        };
        var result = await post(`Usuario/ChangePassword`, dto);
        if (result && result.data) {
          Swal.fire({
            icon: 'success',
            title: '¡Se ha actualizado la contraseña correctamente!',
            text: 'Favor ingresar sus credenciales para autenticarse'
          });
          history.push({
              pathname: "/",
              state: {}
          });
        } else {
          Swal.fire({
            icon: 'warning',
            title: '¡Atención!',
            text: '¡Favor intente nuevamente!'
          });
        }
      } catch (error) {
        console.log(error)
        Alerts.operationFail()
      } finally {
        props.SetLoading(false);
      }
    } else {
      Swal.fire({
        icon: 'warning',
        title: '¡Atención!',
        text: '¡Las contraseñas son distintas!'
      });
    }
  }

  return (
    <>
      {
        props.loading ? (
          <div className={'display-flex flex-direction-row flex-center'}>
            <Spinner style={loadingClases} variant="primary" className={'is-absolute center-spinner-vertically'} animation="border" size="lg" />
          </div>
        ) : <div></div>
      }
      <div className="display-flex flex-center center-vertical flex-direction-column height-100 login-background">
        <div className={'padding-10'}>

          <div className={'display-flex flex-end'}>
            <img style={logoStyle} src={logo} alt="logo" />
          </div>

          <Card className="card-login">
            <Card.Body className={'p-30'}>
              <Formik
                validationSchema={schema}
                onSubmit={onSumitted}
                initialValues={formContent}
                enableReinitialize={true}
              >
                {({
                  handleSubmit,
                  handleChange,
                  handleBlur,
                  values,
                  touched,
                  isValid,
                  errors,
                }) => (
                  <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
                    <Form.Row>

                      <Form.Group as={Col} md="12" controlId="validationFormik01">
                        <Form.Label> <strong> Correo </strong> </Form.Label>
                        <Form.Control
                          type="email"
                          name="userName"
                          value={values.userName}
                          onChange={handleChange}
                          isValid={touched.userName && !errors.userName}
                          isInvalid={!!errors.userName}
                          disabled={true}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.userName}
                        </Form.Control.Feedback>
                      </Form.Group>

                      <Form.Group as={Col} md="6" controlId="validationFormik02">
                        <Form.Label> <strong> Nueva contraseña </strong> </Form.Label>
                        <Form.Control
                          className="is-password"
                          type="text"
                          name="newPassword"
                          value={values.newPassword}
                          onChange={handleChange}
                          isValid={touched.newPassword && !errors.newPassword}
                          isInvalid={!!errors.newPassword}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.newPassword}
                        </Form.Control.Feedback>
                      </Form.Group>

                      <Form.Group as={Col} md="6" controlId="validationFormik02">
                        <Form.Label> <strong> Confirmar nueva contraseña </strong> </Form.Label>
                        <Form.Control
                          className="is-password"
                          type="text"
                          name="confirmNewPassword"
                          value={values.confirmNewPassword}
                          onChange={handleChange}
                          isValid={touched.confirmNewPassword && !errors.confirmNewPassword}
                          isInvalid={!!errors.confirmNewPassword}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.confirmNewPassword}
                        </Form.Control.Feedback>
                      </Form.Group>

                    </Form.Row>

                    <center>
                      <ReCAPTCHA
                        style={{ marginBottom: 10 }}
                        sitekey={process.env.REACT_APP_NEXT_PUBLIC_RECAPTCHA_SITE_KEY}
                        onChange={setReCAPTCHA}
                        ref={reRef}
                        hl={'es'}
                      />

                      <div>
                        <Button style={{width: '50%', marginTop: 10}} disabled={reCAPTCHA === ""} variant="dark" type="submit"><strong>  Cambiar contraseña </strong> </Button>
                      </div>
                    </center>

                  </Form>
                )}
              </Formik>
            </Card.Body>
          </Card>
  
        </div>
      </div>
    </>
  );
}


const mapStateToProps = (state) => {
  return {
    user: state.user,
    loading: state.loading
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    SetUser: (user) => dispatch(SetUser(user)),
    SetLoggedIn: (value) => dispatch(SetLoggedIn(value)),
    SetLoading: (value) => dispatch(SetLoading(value))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps)(ChangePasswordStepTwo);